<div class="view-user-container">
	@if (avatarData) {
		<div class="avatar-container">
			<au-round-avatar [data]="avatarData" [size]="120"></au-round-avatar>
		</div>
	}

	<div
		class="data-container"
		[ngStyle]="{
			'flex-basis': avatarData ? '70%' : '100%',
		}"
	>
		@for (item of repeatableItems; track item) {
			<au-data-element
				class="bio-element"
				[data]="item.data"
				[label]="item.label"
			></au-data-element>
		}
	</div>
</div>
